import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonShape, ButtonVariant, IconName } from '@as/cotopaxi';
import { RANGE_FILTER, BUCKET_FILTER } from '@as-react/common-types';
import { capitalizeOnly, isNullOrUndefined } from '@as-react/common-utils';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { FILTER_SIZE_SEPARATOR } from '../../../constants/GeneralConstants';
export const AppliedFilterItem = ({ activeFilterItem, onToggleFilter, size }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const mapActiveFilterItemToSetFilterObject = (activeFilter) => activeFilter.filterType === RANGE_FILTER
        ? {
            filterOn: activeFilter.filterOn,
            filterOnName: activeFilter.filterOnName,
            filteredItems: [
                { filterKey: activeFilter.rangeMin.toString() },
                { filterKey: activeFilter.rangeMax.toString() },
            ],
            filterType: activeFilter.filterType,
            filterContentType: activeFilter.filterContentType,
            isReset: true,
        }
        : {
            filterOn: activeFilter.filterOn,
            filterOnName: activeFilter.filterOnName,
            filteredItems: [
                {
                    filterType: activeFilter.filterType,
                    filterKey: activeFilter.filterKey,
                    filterKeyName: activeFilter.filterKeyName,
                    filterOn: activeFilter.filterOn,
                    filterOnName: activeFilter.filterOnName,
                },
            ],
            filterType: activeFilter.filterType,
            filterContentType: activeFilter.filterContentType,
            queryParamKey: activeFilter.queryParamKey,
        };
    const getTextRangeValue = (value) => [activeFilterItem.filterPrefix, value.toString(), activeFilterItem.filterSuffix]
        .filter(item => !isNullOrUndefined(item))
        .join('');
    const getTextSelect = () => activeFilterItem.filterType === BUCKET_FILTER
        ? `${activeFilterItem.filterOnName}: ${capitalizeOnly(activeFilterItem.filterKeyName)}`
        : capitalizeOnly(activeFilterItem.filterKeyName.split(FILTER_SIZE_SEPARATOR)[0]);
    const getTextRange = () => t('product.filter.range', {
        name: activeFilterItem.filterOnName,
        min: getTextRangeValue(activeFilterItem.rangeMin),
        max: getTextRangeValue(activeFilterItem.rangeMax),
    });
    const getText = () => (activeFilterItem.filterType === RANGE_FILTER ? getTextRange() : getTextSelect());
    const getTitle = () => activeFilterItem.filterType === RANGE_FILTER
        ? `${activeFilterItem.filterOnName}: ${getTextRangeValue(activeFilterItem.rangeMin)} - ${getTextRangeValue(activeFilterItem.rangeMax)}`
        : `${activeFilterItem.filterOnName} - ${capitalizeOnly(activeFilterItem.filterKeyName).split(FILTER_SIZE_SEPARATOR)[0]}`;
    return (_jsx(Button, { variant: ButtonVariant.FILTER, shape: ButtonShape.PILL, iconRight: { name: IconName.CLOSE }, title: getTitle(), size: size, onClick: () => onToggleFilter(mapActiveFilterItemToSetFilterObject(activeFilterItem)), text: getText(), dataQA: "applied-filter" }));
};
